import React from "react";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";

const SoftwareSkill = ({ icon, title, experience }) => {
  return (
    <div>
      <div data-tip={experience + " years experience"}>
        <SoftwareSkillContainer>
          <IconContainer
            src={require("../../assets/images/" + icon)}
            alt={title}
          ></IconContainer>
          <TitleContainer>{title}</TitleContainer>
        </SoftwareSkillContainer>
      </div>
      <ReactTooltip place="top" type="light" effect="float" />
    </div>
  );
};

export default SoftwareSkill;

const SoftwareSkillContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border-radius: 10px;

  &:hover {
    transition: all 0.3s ease-out;
    background-color: var(--hoverback);
    color: var(--primary);
    text-decoration: none;
  }
`;
const IconContainer = styled.img`
  height: 48px;
  width: 48;
`;
const TitleContainer = styled.p`
  display: block;
  margin-block-start: 1em;
  text-align: center;
  color: var(--secondary);
`;
